import React, {useEffect, useState} from 'react';
import {Button, Col, DatePicker, Table, Row, Icon, Tooltip} from "antd";
import {reportService} from "../../../../services/report.services";
import moment from "moment";
import SelectField from "../../../select-field";
import {distributionCenterService} from "../../../../services";
import i18n from "../../../../i18n";
import { useConsignorFilter } from '../../../../hooks/use-consignor-filter';
import ConsignorFilterSelect from '../../../consignor-filter-select';


export default function ReportStatsDriversLocation() {

  const consignorFilter = useConsignorFilter();
  const { isOwnerUser, consignors, selectedConsignor, setSelectedConsignor, getCompaniesWithConsignor } = consignorFilter;

  const [loading, setLoading] = useState(false);
  const [companiesLoaded, setCompaniesLoaded] = useState(false);
  const [isNeedUpdateReport, setIsNeedUpdateReport] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(true);
  const [errorMsg, setErrorMsg] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(0);

  const [distCenters, setDistCenters] = useState([]);
  const [selectedDistCenters, setSelectedDistCenters] = useState([]);

  // параметры для построения отчета
  const [dateStart, setDateStart] = useState(moment().startOf('month'));
  const [dateEnd, setDateEnd] = useState(moment().endOf('month'));
  // полученные данные отчета
  const [reportData, setReportData] = useState([]);

  const colW = (isOwnerUser ? 4 : 5);

  // перезагружаем компании при смене consignor
  useEffect(() => {
    if (!companiesLoaded) return;
    setCompaniesLoaded(false);
  }, [selectedConsignor])

  // при первом открытии автоматически запрашиваем данные
  useEffect(() => {
    if (loading === false) {
      setLoading(true);
      setIsNeedUpdateReport(true);

      if (!companiesLoaded) {
        getCompaniesWithConsignor()
          .then((response) => {
            setDistCenters(response);
            setCompaniesLoaded(true);
          })
          .catch((errorMsg) => {
            setErrorMsg(errorMsg);
            setCompaniesLoaded(true);
          });
      }
    }
  }, [companiesLoaded]);

  if (isNeedUpdateReport) {

    // запрос на получение данных отчета
    reportService
        .getStatsDriversLocation(
            dateStart.format('YYYY-MM-D'), dateEnd.format('YYYY-MM-D'), selectedDistCenters, selectedStatus, isOwnerUser ? selectedConsignor : null
        )
        .then((reportData) => {

          const reportDataParsed = reportData.map(item => {
            return {
              deliveryID: item.deliveryID,
              deliveryNumber: item.deliveryNumber,
              deliveryStatus: item.deliveryStatus,
              legalEntityName: item.legalEntityName,
              driverName: item.driverName,
              logistFIO: item.logistFIO,
              dateStartSendLocation: item.dateStartSendLocation,
              dateEndSendLocation: item.dateEndSendLocation,
              deliveryArchivedByLocation: item.deliveryArchivedByLocation,
              countLocationTranslations: item.countLocationTranslations,
            };
          });

          setIsNeedUpdateReport(false);
          setLoading(false);
          setReportData(reportDataParsed);

        })
        .catch((errorMsg) => {
          setIsNeedUpdateReport(false);
          setLoading(false);
          setErrorMsg(errorMsg);
        });
  }

  // отображение фатальной ошибки
  if (errorMsg) {
    return (<div className="content-error-block">{errorMsg}</div>);
  }

  // список столбцов таблицы
  const columns = [
    {
      title: i18n.t('reportsPage.statsDriversLocation.table.deliveryNumber.title'),
      dataIndex: 'deliveryNumber',
      key: 'deliveryNumber',
      width: '10%',
      ellipsis: true,
    },
    {
      title: <Tooltip title={i18n.t('reportsPage.statsDriversLocation.table.deliveryStatus.hint')}>{i18n.t('reportsPage.statsDriversLocation.table.deliveryStatus.title')}</Tooltip>,
      dataIndex: 'deliveryStatus',
      key: 'deliveryStatus',
      width: '10%',
      ellipsis: true,
    },
    {
      title: i18n.t('reportsPage.statsDriversLocation.table.legalEntityName.title'),
      dataIndex: 'legalEntityName',
      key: 'legalEntityName',
      ellipsis: true,
    },
    {
      title: i18n.t('reportsPage.statsDriversLocation.table.driverName.title'),
      dataIndex: 'driverName',
      key: 'driverName',
      ellipsis: true,
    },
    {
      title: i18n.t('reportsPage.statsDriversLocation.table.logistFIO.title'),
      dataIndex: 'logistFIO',
      key: 'logistFIO',
      ellipsis: true,
    },
    {
      title: i18n.t('reportsPage.statsDriversLocation.table.locationDate.title'),
      key: 'locationDate',
      ellipsis: true,
      render: (record) => {
        if (!record.dateStartSendLocation) {
          return '-';
        }
        // TODO проверить перевод!
        return (
            <>
              <span dangerouslySetInnerHTML={{__html: i18n.t('reportsPage.statsDriversLocation.table.locationDate.content.start', {dateStartSendLocation:record.dateStartSendLocation})}}/> <br/>
              <span dangerouslySetInnerHTML={{__html: i18n.t('reportsPage.statsDriversLocation.table.locationDate.content.end', {dateEndSendLocation:record.dateEndSendLocation})}}/> <br/>
              <span dangerouslySetInnerHTML={{__html: i18n.t('reportsPage.statsDriversLocation.table.locationDate.content.count', {countLocationTranslations:record.countLocationTranslations})}}/>
            </>
        );
      },
    },
    {
      title: i18n.t('reportsPage.statsDriversLocation.table.autoComplete.title'),
      key: 'locationDate',
      ellipsis: true,
      render: (record) => {
        if (record.deliveryStatus !== 'Согласован') {
          return '-';
        }

        return record.deliveryArchivedByLocation ? i18n.t('main.yes') : i18n.t('main.no');
      },
    },
  ];

  return (
      <React.Fragment>
        <div className="reports__header">
          <h1 className="content-header">{i18n.t('reportsPage.statsDriversLocation.title')}</h1>
          <Icon type='filter'
                theme={isFilterOpen ? '' : "filled"}
                onClick={() => {
                  setIsFilterOpen(!isFilterOpen)
                }}
                className="reports__filter-toggle"/>
          {isFilterOpen && <div className={`reports__filter ${isFilterOpen ? 'is-open' : ""}`}>
            <Row gutter={12} style={{padding: "0", rowGap: "10px"}} type="flex" justify="start">
              <Col lg={colW} md={colW} sm={12} xs={24} style={{paddingRight: "10px"}}>
                <DatePicker
                    style={{width: "100%"}}
                    defaultValue={dateStart}
                    format="DD.MM.YYYY"
                    size="normal"
                    name="dateStart"
                    placeholder={i18n.t('reportsPage.statsDriversLocation.filter.dateStart.placeholder')}
                    allowClear={false}
                    onChange={(date) => {
                      setDateStart(date);
                    }}
                />
              </Col>
              <Col lg={colW} md={colW} sm={12} xs={24} style={{paddingRight: "10px"}}>
                <DatePicker
                    style={{width: "100%"}}
                    defaultValue={dateEnd}
                    format="DD.MM.YYYY"
                    size="normal"
                    name="dateEnd"
                    placeholder={i18n.t('reportsPage.statsDriversLocation.filter.dateEnd.placeholder')}
                    allowClear={false}
                    onChange={(date) => {
                      setDateEnd(date);
                    }}
                />
              </Col>
              <Col lg={colW} md={colW} sm={12} xs={24} style={{textAlign: 'right', height: '40px'}}>
                <Button type="primary"
                        htmlType="button"
                        onClick={() => {
                          setLoading(true);
                          setIsNeedUpdateReport(true);
                        }}
                        style={{backgroundColor: '#1CAA53', border: 'none', height: '100%', width: '100%'}}
                >
                  {i18n.t('main.buttons.submit')}
                </Button>
              </Col>
            </Row>
            <Row>
              {isOwnerUser &&
                <Col lg={colW} md={colW} sm={12} xs={24} style={{paddingRight: "10px"}}>
                  <ConsignorFilterSelect
                    isOwnerUser={isOwnerUser}
                    consignors={consignors}
                    selectedConsignor={selectedConsignor}
                    onChange={(value) => {
                      setSelectedConsignor(value);
                      setDistCenters([]);
                      setSelectedDistCenters([]);
                    }}
                  />
                </Col>
              }
              <Col lg={colW} md={colW} sm={12} xs={24} style={{paddingRight: "10px"}}>
                <SelectField
                    name="distributionCenters"
                    selectedValue={selectedDistCenters}
                    values={distCenters}
                    onChange={(value) => {
                      setSelectedDistCenters(value);
                    }}
                    notFoundText={i18n.t('reportsPage.statsDriversLocation.filter.distributionCenters.empty')}
                    getErrors={() => {
                    }}
                    style={{width: "100%"}}
                    mode={'multiple'}
                />
              </Col>
              <Col lg={colW} md={colW} sm={12} xs={24} style={{paddingRight: "10px"}}>
                <SelectField
                    name="deliveryStatus"
                    selectedValue={selectedStatus}
                    values={[
                      {id: 0, name: i18n.t('reportsPage.statsDriversLocation.filter.deliveryStatus.values.all')},
                      {id: 13, name: i18n.t('reportsPage.statsDriversLocation.filter.deliveryStatus.values.enRoute')},
                      {id: 15, name: i18n.t('reportsPage.statsDriversLocation.filter.deliveryStatus.values.archive')},
                    ]}
                    onChange={(value) => {
                      setSelectedStatus(value);
                    }}
                    getErrors={() => {
                    }}
                    style={{width: "100%"}}
                />
                </Col>
              </Row>
           </div>}
        </div>
        <div className="reports__table">
          <div className="reports__table-wrapper">
            <Col span={24}>
              <Table
                  style={{minWidth: '100%'}}
                  columns={columns}
                  dataSource={reportData}
                  locale={{emptyText: i18n.t('main.empty')}}
                  rowKey={"userId"}
                  loading={loading}
                  size="small"
                  pagination={{pageSize: 50}}
              />

            </Col>
          </div>
        </div>
      </React.Fragment>
  );
}
